import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import { patternOnlyNumbers } from "../../../../../shared/create-offer/utils/masks";

import { useNewOfferMobile } from "../../context";
import AcceptanceTerms from "../../../../../shared/create-offer/AcceptanceTerms/AcceptanceTerms";
import InfoBankStep from "./infosSeeMore/InfoBankStep"

const AgencyInput = ({ step, bankData, onChangeBankData, acceptanceTerms, setAcceptanceTerms }) => {
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		account: bankData.data.account || "",
		type: bankData.data.type || "",
		hasError: false
	});

	useEffect(() => {
		setStepError(!state.account.length || !acceptanceTerms);
	}, [state, acceptanceTerms]);

	const onChange = ev => {
		let account = ev.target.value.match(patternOnlyNumbers)
			? ev.target.value
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";
		setState({
			...state,
			account: account.replace(/(\d)(\d{1}$)/g, "$1-$2"),
			hasError: !account.length
		});

		onChangeBankData({ account: account.replace(/(\d)(\d{1}$)/g, "$1-$2") });
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados bancários
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="account"
					id="account"
					type="tel"
					value={state.account}
					onChange={onChange}
					placeholder=""
					label= "Conta corrente"
					maxLength="20"
					hasError={state.hasError}
					errorMessage="Preencha corretamente o campo conta."
					data-action="register-bank-details-account"
				/>
			</div>

			<AcceptanceTerms
				acceptanceTerms={acceptanceTerms}
				setAcceptanceTerms={setAcceptanceTerms}
			/>

			<InfoBankStep/>
		</div>
	);
};

export default AgencyInput;
